import { WarningOutlined } from '@ant-design/icons'
import styled from '@emotion/styled'
import { TextStylePreset, Typography } from '@vivaldis/antd-ui'
import { useTheme } from '@vivaldis/ui'
import { useTranslation } from 'react-i18next'

export const MissingInformationTag = () => {
  const [t] = useTranslation('web_ui')
  const theme = useTheme()

  return (
    <Base>
      <WarningOutlined style={{ fontSize: 12, color: theme.red6 }} />
      <Typography.Text preset={TextStylePreset.Regular12} color={theme.red6}>
        {t('employee_profile.missing_information')}
      </Typography.Text>
    </Base>
  )
}

const Base = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
`
